import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { MatLegacySnackBarModule as MatSnackBarModule  from '@angular/material/legacy-snack-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
// import { LottieModule } from 'ngx-lottie';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
// import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
// import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatCardModule } from '@angular/material/card';
// import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
// import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
// import { MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatDialogModule } from '@angular/material/dialog';
// import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
// import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
// import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { APIService } from '../services/api.service';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import { LandingPageRoutingModule } from './landing-page.routing.module';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LeadFormComponent } from '../shared/lead-form/lead-form.component';
import { TermsComponent } from '../shared/terms/terms.component';
import { PrivacyComponent } from '../shared/privacy/privacy.component';
import { SalesComponent } from './sales/sales.component';
import { SitemapComponent } from '../shared/sitemap/sitemap.component';
import { LegalComponent } from '../shared/legal/legal.component';
import { NewHomeComponent } from './home/new-home.component';
import { NewHeaderComponent } from '../shared/new-header/new-header.component';
import { NewFooterComponent } from '../shared/new-footer/new-footer.component';
import { ProductComponent } from './product/product.component';
import { NewAboutComponent } from './about/new-about.component';
import { NewContactComponent } from './contact/new-contact.component';
import { BodyComponent } from '../shared/body/body.component';
import { CardsWrapComponent } from '../shared/cards-wrap/cards-wrap.component';
import { ShimmerUiComponent } from '../shared/shimmer-ui/shimmer-ui.component';
import { WeDoComponent } from '../shared/we-do/we-do.component';
import { FadeComponentComponent } from '../shared/fade-component/fade-component.component';

// import { NgImageSliderModule } from 'ng-image-slider';
import { AppJobModule } from '../app-job/app-job.module';
import { SharedModule } from '../shared/shared.module';
import { AttendanceComponent } from './attendance/attendance.component';
import { PublicPageComponent } from './public-page/public-page.component';
import { FeaturesCardComponent } from './features-card/features-card.component';
import { FourPillarsComponent } from './four-pillars/four-pillars.component';
import { WhyInforidaComponent } from './why-inforida/why-inforida.component';
import { AdminStaffComponent } from './admin-staff/admin-staff.component';
import { AcademicStaffComponent } from './academic-staff/academic-staff.component';
import { ParentsComponent } from './parents/parents.component';
import { HeadingSmallComponentComponent } from '../shared/heading-small-component/heading-small-component.component';
import { HowWeDoComponent } from './how-we-do/how-we-do.component';
import { MatCard } from '@angular/material/card';
import { BlogsComponent } from './blogs/blogs.component';
import { NgxGradientTextComponent } from '@omnedia/ngx-gradient-text';
import { NgxMarqueeComponent } from '@omnedia/ngx-marquee';
import { NgxTimelineComponent } from '@omnedia/ngx-timeline';
import { NgxHaloComponent } from '@omnedia/ngx-halo';
import { NgxFadeComponent } from '@omnedia/ngx-fade';
import { NgxShineBorderComponent } from '@omnedia/ngx-shine-border';
import { NgxBorderBeamComponent } from '@omnedia/ngx-border-beam';
// import { NgxBackgroundBeamsComponent } from '@omnedia/ngx-background-beams';
import { NgxDotpatternComponent } from '@omnedia/ngx-dotpattern';
import { NgxShinyTextComponent } from '@omnedia/ngx-shiny-text';

@NgModule({
  declarations: [
    LandingPageComponent,
    // LeadFormComponent,
    // TermsComponent,
    // PrivacyComponent,
    SalesComponent,
    // SitemapComponent,
    // LegalComponent,
    NewHomeComponent,
    // NewFooterComponent,
    ProductComponent,
    // NewHeaderComponent,
    NewAboutComponent,
    NewContactComponent,
    AttendanceComponent,
    PublicPageComponent,
    // BodyComponent,
    // ShimmerUiComponent,
    FeaturesCardComponent,
    // CardsWrapComponent,
    FourPillarsComponent,
    WhyInforidaComponent,
    AdminStaffComponent,
    AcademicStaffComponent,
    ParentsComponent,
    // HeadingSmallComponentComponent,
    HowWeDoComponent,
    // WeDoComponent,
    BlogsComponent,
  ],
  imports: [
    CommonModule,
    LandingPageRoutingModule,
    MatToolbarModule,
    MatIconModule,
    MatFormFieldModule,
    MatButtonModule,
    MatGridListModule,
    MatCardModule,
    MatTabsModule,
    MatMenuModule,
    MatDialogModule,
    MatInputModule,
    FormsModule,
    MatRadioModule,
    MatSnackBarModule,
    // NgImageSliderModule,
    // LottieModule,
    AppJobModule,
    SharedModule,
    NgxGradientTextComponent,
    NgxMarqueeComponent,
    NgxTimelineComponent,
    NgxHaloComponent,
    NgxFadeComponent,
    FadeComponentComponent,
    NgxShineBorderComponent,
    NgxBorderBeamComponent,
    // NgxBackgroundBeamsComponent,
    NgxDotpatternComponent,
    NgxShinyTextComponent,
  ],
  providers: [APIService, GoogleAnalyticsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LandingPageModule {}
